import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  root: {
    height: '100vh',
    width: '100vw',
    overflowX: 'hidden',
  },
  body: {
    display: 'flex',
  },
  container: {
    marginTop: 30,
    padding: '32px 0',
    margin: '0 24px',
    maxWidth: (props: { maxWidth: string }) => `${props.maxWidth}`,
  },
});

export default useStyles;
